import { Injectable } from '@angular/core';
import { Monedas } from 'app/obj/monedas';
import { environment } from '../../environments/environment';
import {Http, Response, Headers} from '@angular/http';

@Injectable()
export class CurrencyService {
  
  private usuariogeoname:string = "hanzscorpio";
  private currency:string = "COP";
  private valor = 0;
  public monedas = [];

  constructor(private http:Http) { 
    this.getUbicacion();
  }

  getUbicacion(){
    this.getPosicion().then(pos => {
        let url="http://api.geonames.org/countryCodeJSON?lat="+pos.lat+"&lng="+pos.lng+"&username="+this.usuariogeoname;
        return this.http
        .get(url)
        .toPromise()
        .then(
          response => {
              if(response.json().countryName == 'Colombia') {
                 this.currency = "COP";
              }else {
                this.currency = "USD";
              }
              this.setCurrency(this.currency);
          },
          reject => {
              return reject.json();  
          }
        ).catch(this.handleError);
    });   
  }

  getPosicion(): Promise<any> {
    if (navigator.geolocation) {
      return new Promise((resolve, reject) => {
          navigator.geolocation.getCurrentPosition(posicion => {
                resolve({lng: posicion.coords.longitude, lat: posicion.coords.latitude});
            },
            err => {
                switch(err.code) {
                  case err.PERMISSION_DENIED:
                      // El usuario denegó el permiso para la Geolocalización.
                      break;
                  case err.POSITION_UNAVAILABLE:
                      // La ubicación no está disponible.
                      break;
                  case err.TIMEOUT:
                      // Se ha excedido el tiempo para obtener la ubicación.
                      break;
                }

                this.setCurrency('COP');
          });

      });
    }
  }

  getCurrency()
  {
    return this.currency;
  }
  setCurrency(currency)
  {
    this.currency = currency;
    console.log("Currency Changed to: "+this.currency);
  }

  getValor()
  {
    return this.valor;
  }

  setValor(valor)
  {
    this.valor = valor;
  }

  getMoneda(){        
    let headers = new Headers({'Content-Type': 'application/json; charset=utf-8'});
    let url=environment.serviceUrl+'monedas';
    
    return this.http
    .get(url, {headers: headers})
    .toPromise()
    .then(
      response => {
          return response.json() as Monedas;        
      },
      reject => {
        let monedas = [
          { indice: "COP", descripcion: "Peso Colombiano" },{ indice: "USD", descripcion: "Dolar Americano" },
          { indice: "ARS", descripcion: "Peso Argentino" },{ indice: "PEN", descripcion: "Nuevo Sol Peruano" },
          { indice: "MXN", descripcion: "Peso Mexicano" },{ indice: "CLP", descripcion: "Peso Chileno" }
        ];
        return monedas;
      }
      )
    .catch(this.handleError);
  }   

 
      /**
   * Handles error thrown during HTTP call
   * @param error:any
   * @returns {Promise<never>}
   */
       private handleError(error: any): Promise<any> {
        console.error('An error occurred', error); //
        return Promise.reject(error.message || error);
      }
}



// WEBPACK FOOTER //
// ./src/app/services/currency.service.ts